const colorPrimaryGradient =
  'linear-gradient(180deg, #FDCB40 0%, #FFB533 100%)';
export type HexColor = `#${string}`;

const colorPrimary = 'rgba(241, 255, 10, 1)';
const colorPrimaryLight = 'rgba(241, 255, 10, 0.5)';
// const colorBackgroundDark = 'rgba(39, 46, 58, 1)';
const colorBackgroundLight = 'rgba(176, 176, 176, 1)';
// const colorBackgroundMedium = 'rgba(55, 63, 76, 1)';

const colorBackgroundWhite = 'rgb(245 245 245)';
const colorBackgroundDark = '#1D1D1D';
const colorBackgroundDarkPurple = '#161622'; //dark purple
const paywallPremiumGradient =
  'linear-gradient(90deg, #8681FA 33.02%, #D16FD9 93.75%)';
const colorBackgroundMedium = 'rgb(31 34 45)'; //'rgb(43 43 45)';//'rgb(56 56 67)'//'#2d2d36';
const cardBackground = '#303031';
const completeProfileGradient =
  'radial-gradient(84.64% 84.64% at 5.43% 5.01%, #8183FC 0%, #A679EB 25.37%, #D66DD6 100%)';
// const colorBackgroundLight = 'white';

// #161622 - app header main dark color

const CHAT_ELEMENTS_BG_COLOR: HexColor = '#f5f5f5';

const primaryFontFamily = "'Roboto', sans-serif";

const UIConfig = {
  Fonts: {
    Primary: primaryFontFamily
  },
  Colors: {
    PrimaryGradient: colorPrimaryGradient,
    Primary: colorPrimary,
    PrimaryLight: colorPrimaryLight,
    BackgroundMedium: colorBackgroundMedium,
    BackgroundLight: colorBackgroundLight,
    BackgroundDark: colorBackgroundDark,
    BackgroundDarkPurple: colorBackgroundDarkPurple,
    BackgroundWhite: colorBackgroundWhite,
    GradientPremium: paywallPremiumGradient,
    CompleteProfileGradient: completeProfileGradient,
    UploadProgress: '#ffffff'
  },
  TabBar: {
    Content: {
      background: colorBackgroundDark,
      color: '#FFF',
      height: '80px'
    },
    Icon: {
      Background: '#BABABA',
      Color: '#000'
    },
    IconActive: {}
  },
  Card: {
    Content: {
      borderRadius: '35px',
      background: cardBackground
    },
    LikeButton: {
      background: colorPrimary,
      borderRadius: '35px',
      color: '#000',
      fontSize: '24px',
      height: '55px'
    },
    PassButton: {
      background: '#FFF',
      color: '#000',
      borderRadius: '35px'
    },
    Header: {
      background: colorBackgroundDark,
      color: '#FFF'
    }
  },
  Typography: {
    Card: {
      Title: {
        fontSize: '22px',
        fontWeight: 700,
        color: '#FFFFFF',
        lineHeight: '20px',
        letterSpacing: '0.5px'
      },
      SubTitle: {
        fontFamily: primaryFontFamily,
        color: '#ffffff',
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '16px',
        letterSpacing: '0.4px'
      },
      AboutMe: {
        fontFamily: primaryFontFamily,
        fontSize: '14px',
        fontWeight: 400,
        color: '#FFF',
        lineHeight: '16px',
        letterSpacing: '0.4px'
      }
    }
  },
  Profile: {
    Input: {
      borderRadius: '15px'
    }
  },
  Chat: {
    shared: {
      backgroundColor: CHAT_ELEMENTS_BG_COLOR
    }
  }
};

export default UIConfig;
